import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

export const MEMBER_KEY = "uwc_member";

export const loadStoredMember = () => {
  try {
    const raw = localStorage.getItem(MEMBER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const storeMember = (member) => {
  localStorage.setItem(MEMBER_KEY, JSON.stringify(member));
};
